import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { Link } from 'react-router-dom'
import { TdActions } from '@/components/tdActions'
import Icon from '@/components/Icon'
import { Frequency } from '@/enums/Frequency'
import { formatOffset } from '@/utils/StringUtilities'
import getEnumTranslation from '@/enums/enums'
import { DueDateWeekly } from '@/enums/DueDateWeekly'
import { formatDate } from '@/utils/dateUtilities'
import find from 'lodash/find'
import LoadingIndicator from '@/components/LoadingIndicator'
import { dialogTypes } from '@/dialogs'

export const nameGridCell = (props) => {
  return class GridName extends GridCell {
    componentDidMount () {
      this.fetchCollisionDates()
    }
    componentDidUpdate (prevProps, prevState) {
      this.fetchCollisionDates()
    }
    shouldFetch () {
      const collisionDates = this.findCollisionDates()
      return !collisionDates || (collisionDates.fetching === false && collisionDates.fetched === false && collisionDates.error === null)
    }
    fetchCollisionDates () {
      if (this.shouldFetch()) {
        props.getCollisionDates(this.props.dataItem.id)
      }
    }
    findCollisionDates (id) {
      return find(props.reportingCycleCollisions.collisionDates, x => x.reportingCycleId === this.props.dataItem.id)
    }
    render () {
      const name = this.props.dataItem[props.localizeProps()]
      const collisionDates = this.findCollisionDates()
      const isLoading = !collisionDates || ((collisionDates || {}).fetching === true)
      const count = ((collisionDates || {}).dates || []).length
      const showFixInfo = count > 0

      return <td>
        {name}
        {isLoading && <LoadingIndicator inline />}
        {showFixInfo && <Link className='btn btn-xs btn-danger' to={`/reporting-calendars/${props.year}/reporting-cycles/${this.props.dataItem.id}`}>
          {props.localize('Reporting.FixConflicts')}<span className='badge badge-light'>{count}</span>
        </Link>}
      </td>
    }
  }
}

export const dateCell = (props) => {
  return class DateCell extends GridCell {
    getText (props) {
      const { localize } = props
      const { frequency, snapshotIntValue, snapshotDateValue, snapshotOffset, dueIntValue, dueDateValue, dueOffset } = this.props.dataItem
      switch (frequency) {
        case Frequency.DAILY: return localize('Reporting.Daily') + (props.isDueDate ? formatOffset(dueOffset.toString()) : '')
        case Frequency.WEEKLY: return (props.isDueDate ? formatWeeklyText(dueIntValue, dueOffset, 'WeekDay', localize) : formatWeeklyText(snapshotIntValue, snapshotOffset, 'WeekDay', localize))
        case Frequency.BIWEEKLY: return (props.isDueDate ? formatWeeklyText(dueIntValue, dueOffset, 'BiweekDay', localize) : formatWeeklyText(snapshotIntValue, snapshotOffset, 'BiweekDay', localize))
        case Frequency.MONTHLY: return (props.isDueDate ? formatMonthlyText(dueIntValue, dueOffset, 'DueDateMonthly', localize) : formatMonthlyText(snapshotIntValue, snapshotOffset, 'SnapshotDateMonthly', localize))
        case Frequency.QUARTERLY: return (props.isDueDate ? formatMonthlyText(dueIntValue, dueOffset, 'DueDateQuarterly', localize) : formatMonthlyText(snapshotIntValue, snapshotOffset, 'SnapshotDateQuarterly', localize))
        case Frequency.YEARLY: return (props.isDueDate ? formatDate(dueDateValue) : formatDate(snapshotDateValue))
      }
    }
    render () {
      return <td>{this.getText(props)}</td>
    }
  }
}

export const frequencyCell = (props) => {
  return class FrequencyCell extends GridCell {
    render () {
      const { localize } = props
      return <td>{getEnumTranslation({ localize, enumName: 'Frequency', value: this.props.dataItem.frequency })}</td>
    }
  }
}

export const commandCell = (props) => {
  return class CommandCell extends GridCell {
    handleDeleteClick () {
      props.openDialog({
        dialogType: dialogTypes.confirm,
        title: 'Common.Delete',
        content: 'Common.AreYouSure',
        primaryButtonText: 'Common.Yes',
        onAction: () => { props.deleteCycle(this.props.dataItem.id) }
      })
    }
    render () {
      return <TdActions>
        <Link className='btn-icon' to={`/reporting-calendars/${props.year}/reporting-cycles/${this.props.dataItem.id}`}><Icon name='pencil' /></Link>
        {this.props.dataItem.canDelete && !props.disabled && <button className='btn-icon' onClick={() => this.handleDeleteClick()}><Icon name='x' /></button>}
      </TdActions>
    }
  }
}

const formatWeeklyText = (intValue, offset, enumName, localize) => {
  if (intValue === DueDateWeekly.WEEK_DAY) {
    return getEnumTranslation({ localize, enumName, value: offset })
  } else {
    return getEnumTranslation({ localize, enumName: 'DueDateWeekly', value: DueDateWeekly.OFFSET }).replace('#', offset)
  }
}

const formatMonthlyText = (intValue, offset, enumName, localize) => {
  return getEnumTranslation({ localize, enumName, value: intValue }).replace('#', offset)
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportingCycles/gridButtons.js